import { IStatus } from '@dfl/mui-react-common';
import { GREEN, RED, WARNING } from 'settings/theme';

export enum SOLUTION_STATUS {
  PENDING = 'PENDING',
  ERROR = 'ERROR',
  DONE = 'DONE',
}

export const INCIDENCE_RESOLUTION_STATUS: IStatus[] = [
  { _id: SOLUTION_STATUS.PENDING, title: 'status.OPEN', color: WARNING },
  { _id: SOLUTION_STATUS.DONE, title: 'status.RESOLVED', color: GREEN },
  { _id: SOLUTION_STATUS.ERROR, title: 'status.ERROR', color: RED },
];

export const INCIDENCE_RESOLUTION_STATUS_MAP = new Map<string, IStatus>([
  [SOLUTION_STATUS.PENDING, INCIDENCE_RESOLUTION_STATUS[0]],
  [SOLUTION_STATUS.DONE, INCIDENCE_RESOLUTION_STATUS[1]],
  [SOLUTION_STATUS.ERROR, INCIDENCE_RESOLUTION_STATUS[2]],
]);
